const sameItems = (a = [], b = []) =>
  a.length === b.length && a.every((item) => b.includes(item));

const stripFormFlags = ({ isNewRole, isDeleted, ...role }) => role;

export const getProjectTeamChanges = (
  formFieldValues,
  projectRoles,
  projectViewers
) => {
  const values = typeof formFieldValues === "object" ? formFieldValues : {};
  const currentRoles = projectRoles ?? [];
  const currentRoleIds = currentRoles.map(({ id }) => id);
  const fields = Object.values(values).filter(
    (field) => field && typeof field === "object" && !Array.isArray(field)
  );

  const deletedIds = fields
    .filter((field) => field.isDeleted)
    .map(({ id }) => id);

  const rolesToAdd = fields
    .filter((field) => field.isNewRole && !field.isDeleted)
    .filter(({ id }) => !currentRoleIds.includes(id))
    .map((role) => ({
      ...stripFormFlags(role),
      assignedUsers: role.assignedUsers || [],
    }));

  const roleIdsToDelete = currentRoles
    .filter((role) => !role.regionId || deletedIds.includes(role.id))
    .map(({ id }) => id);

  const rolesToUpdate = currentRoles
    .filter((role) => !roleIdsToDelete.includes(role.id) && values[role.id])
    .map((role) => {
      const field = values[role.id];
      const change = { id: role.id };

      const assignedUsers = field.assignedUsers || [];
      if (!sameItems(assignedUsers, role.assignedUsers || [])) {
        change.assignedUsers = assignedUsers;
      }

      if (
        (field.isCoreTeam === true || field.isCoreTeam === false) &&
        field.isCoreTeam !== !!role.isCoreTeam
      ) {
        change.isCoreTeam = field.isCoreTeam;
      }

      return change;
    })
    .filter((change) => Object.keys(change).length > 1);

  const currentViewers = projectViewers ?? [];
  const nextViewers = values.projectViewers ?? currentViewers;

  return {
    rolesToAdd,
    rolesToUpdate,
    roleIdsToDelete,
    viewersToAdd: nextViewers.filter((v) => !currentViewers.includes(v)),
    viewersToRemove: currentViewers.filter((v) => !nextViewers.includes(v)),
  };
};

export const hasProjectTeamChanges = (changes) =>
  Object.values(changes).some((list) => list.length > 0);
